"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimestampFeature = function (features) {
    return features.timestamp;
};
exports.getMeasureFeature = function (features) {
    return features.measure;
};
exports.buildTimestampAccessor = function (effectiveDefinition) {
    var timestamp = exports.getTimestampFeature(effectiveDefinition.features);
    if (!timestamp) {
        return undefined;
    }
    return function (dataRow) { return dataRow[timestamp.column]; };
};
exports.buildMeasureAccessor = function (effectiveDefinition) {
    var measure = exports.getMeasureFeature(effectiveDefinition.features);
    return function (dataRow) { return dataRow[measure.column]; };
};
//# sourceMappingURL=metricValue.js.map